import { render, staticRenderFns } from "./idle-detail.vue?vue&type=template&id=050c8bbb&scoped=true"
import script from "./idle-detail.vue?vue&type=script&lang=js"
export * from "./idle-detail.vue?vue&type=script&lang=js"
import style0 from "./idle-detail.vue?vue&type=style&index=0&id=050c8bbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c8bbb",
  null
  
)

export default component.exports